var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferencesMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 235,
    viewBox: "0 0 298 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.891 145.567C274.585 137.751 270.087 129.291 262.103 127.152L48.9625 70.0408C40.9776 67.9013 32.8528 72.9796 31.2775 81.0946L8.99463 195.882C7.56797 203.231 12.0687 210.432 19.2999 212.369L216.627 265.243C223.858 267.18 231.356 263.195 233.795 256.117L271.891 145.567Z",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2.59207
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.161 77.917C283.198 70.3117 278.685 62.4944 271.08 60.4566L199.879 41.3785C193.916 39.7807 187.787 43.3195 186.189 49.2828C184.221 56.6288 176.67 60.9883 169.324 59.0199L72.4599 33.0653C64.8546 31.0275 57.0373 35.5408 54.9995 43.1461L52.5675 52.2222C51.6413 55.6792 53.6928 59.2325 57.1497 60.1588L60.5924 61.0812C62.148 61.4981 63.747 60.5749 64.1638 59.0193C64.9512 56.0808 67.9715 54.3371 70.9099 55.1244L254.935 104.434C257.874 105.221 259.618 108.242 258.83 111.18C258.413 112.736 259.337 114.335 260.892 114.751L264.335 115.674C267.792 116.6 271.345 114.549 272.271 111.092L281.161 77.917Z",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2.59207
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1355_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.358 158.907C160.118 159.623 159.693 161.208 160.409 162.448L168.919 177.187L154.18 185.697C152.94 186.413 152.515 187.998 153.231 189.238C153.947 190.478 155.532 190.902 156.772 190.187L173.756 180.381C174.996 179.665 175.421 178.08 174.705 176.84L164.899 159.856C164.183 158.616 162.598 158.191 161.358 158.907Z",
    fill: "url(#paint0_linear_1355_10593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.164 163.744C156.733 161.264 157.582 158.094 160.062 156.662C162.542 155.23 165.712 156.08 167.144 158.56L176.95 175.544C178.381 178.023 177.532 181.194 175.052 182.625L158.068 192.431C155.588 193.863 152.418 193.013 150.986 190.534C149.555 188.054 150.404 184.884 152.884 183.452L165.378 176.238L158.164 163.744Z",
    stroke: "url(#paint1_linear_1355_10593)",
    strokeWidth: 5.18414
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1355_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.714 149.088C123.998 147.848 122.413 147.424 121.173 148.139L104.189 157.945C102.949 158.661 102.524 160.246 103.24 161.486L113.046 178.47C113.762 179.71 115.347 180.135 116.587 179.419C117.826 178.703 118.251 177.118 117.535 175.878L109.026 161.139L123.765 152.629C125.005 151.913 125.43 150.328 124.714 149.088Z",
    fill: "url(#paint2_linear_1355_10593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.877 145.895C122.356 144.463 125.527 145.313 126.959 147.792C128.39 150.272 127.541 153.442 125.061 154.874L112.566 162.088L119.78 174.582C121.212 177.062 120.362 180.232 117.883 181.664C115.403 183.095 112.233 182.246 110.801 179.766L100.995 162.782C99.5635 160.303 100.413 157.132 102.893 155.7L119.877 145.895Z",
    stroke: "url(#paint3_linear_1355_10593)",
    strokeWidth: 5.18414
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1355_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 137.987C138.065 137.963 136.886 139.103 136.861 140.535L135.9 197.704C135.876 199.136 137.016 200.315 138.448 200.339C139.879 200.364 141.059 199.223 141.083 197.791L142.045 140.622C142.069 139.191 140.928 138.011 139.497 137.987Z",
    fill: "url(#paint4_linear_1355_10593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27 140.491C134.318 137.628 136.678 135.347 139.54 135.395C142.403 135.443 144.685 137.803 144.637 140.666L142.045 140.622L144.637 140.666L143.675 197.835C143.627 200.698 141.267 202.979 138.404 202.931C135.541 202.883 133.26 200.523 133.308 197.661L134.27 140.491Z",
    stroke: "url(#paint5_linear_1355_10593)",
    strokeWidth: 5.18414
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1355_10593",
    x: 134.09,
    y: 146.246,
    width: 59.7561,
    height: 69.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.48018
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.80419
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_10593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_10593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1355_10593",
    x: 84.0988,
    y: 135.478,
    width: 59.7561,
    height: 69.5617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.48018
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.80419
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_10593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_10593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1355_10593",
    x: 117.107,
    y: 125.674,
    width: 43.7309,
    height: 99.9387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.48018
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.80419
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_10593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_10593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_10593",
    x1: 170.022,
    y1: 160.442,
    x2: 161.502,
    y2: 192.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1355_10593",
    x1: 170.022,
    y1: 160.442,
    x2: 161.502,
    y2: 192.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1355_10593",
    x1: 116.442,
    y1: 146.086,
    x2: 107.922,
    y2: 177.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1355_10593",
    x1: 116.442,
    y1: 146.086,
    x2: 107.922,
    y2: 177.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1355_10593",
    x1: 146.822,
    y1: 139.869,
    x2: 131.123,
    y2: 198.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1355_10593",
    x1: 146.822,
    y1: 139.869,
    x2: 131.123,
    y2: 198.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_10593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 235,
    fill: "white",
    transform: "matrix(-1 0 0 1 298 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesMobile);
export default __webpack_public_path__ + "static/media/preferences-mobile.88bb4cba4016394fd0c21324e80ce07d.svg";
export { ForwardRef as ReactComponent };